import React from 'react'
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const EventShow = () => {
    const location = useLocation();
    const { item, description } = location.state || {};
    console.log("item",item)
  return (
    <div>
        
          
                                              <section class="th-blog-wrapper space-top space-extra-bottom">
        <div class="container">
        <Link to="/" className=" th-icon">
                                             Back
                                              </Link>
                                              <div className="row align-items-center">
  {/* Left Side - Image */}
  <div className="col-lg-6">
    <div className="th-blog blog-single has-post-thumbnail">
      <div className="blog-img">
        <a href="blog-details.html">
          <img
            src={item.imageKey}
            alt="Blog"
            style={{ width: "100%", borderRadius: "10px" }}
          />
        </a>
      </div>
    </div>
  </div>

  {/* Right Side - Content */}
  <div className="col-lg-6">
    <div className="blog-content">
      <div className="blog-meta mb-3">
        <a href="blog.html" className="me-3 d-block d-md-inline">
          <i className="fa-solid fa-calendar-days me-1"></i>
          {item.date}
        </a>
        {description !== "aritical" && (
  <a href="blog-details.html" className="d-block d-md-inline">
    <img
      src="assets/img/icon/map.svg"
      alt="location"
      style={{ width: "16px", marginRight: "5px" }}
    />
    {item.address}
  </a>
)}
      </div>
      <h2 className="blog-title mb-2">
        <a href="blog-details.html">{item.name}</a>
      </h2>
      <p className="blog-text">
  {description === "aritical" ? item.address : item.description}
</p>
    </div>
  </div>
</div>

        </div>
    </section>                                      
    </div>
  )
}

export default EventShow